import { PaymentsData } from 'ducks/merchantDucks/payments/types';
import { StatsPerCountryChartData } from 'ducks/merchantDucks/subscriptions/selectors';
import map from 'data/world';

type DataType = Array<StatsPerCountryChartData> | Array<PaymentsData>;

export const convertReceivedDataToGeoJSON = (data: DataType) => {
  let responseKeyFilter;
  let responseTotalType;
  let filterBy;
  const converted: Array<GeoJSON.Feature> = [];
  data.forEach((country: any | StatsPerCountryChartData | PaymentsData) => {
    map.features.forEach((feature: GeoJSON.Feature) => {
      responseKeyFilter = country.name || country.key || country.country_code;
      responseTotalType = country.total || country.doc_count || country.total_active;
      filterBy = country.name ? `name` : `iso_a2`;
      if (responseKeyFilter === feature.properties?.[filterBy]) {
        converted.push(feature);
        converted[converted.length - 1].properties!.density = responseTotalType;
      }
    });
  });
  return converted;
};
